import { HUMAN_TIME_FORMAT } from './date-formats';
import { parseZone, type DatetimeType } from './datetime';
import { type Moment } from './moment-bridge';

export function formatTimeZone(date: string | DatetimeType | Moment) {
  if (!date) {
    return date;
  }
  const value = typeof date === 'string' ? parseZone(date) : date;
  return value.format(HUMAN_TIME_FORMAT);
}
